<!--
 * @Description: 
--> 
<!--
 * @Description: 受理进度
--> 
<template>
  <div class="business-progress">
    <van-nav-bar
      left-text="返回"
      :title="$route.meta.title"
      @click-left="$comm.onClickLeft"
      left-arrow
      v-show="$comm.titleShow()"
      fixed
      >
      <template #title>
        <span 
          @click="topChange('OnlineProgress')" 
          :style="{
            color: currentTabComponent==='OnlineProgress'
          }"
          >
          业务办理
        </span>
        <!-- ｜ -->
        <!-- <span 
          @click="topChange('OfflineProgress')"
          :style="{
            color: currentTabComponent==='OfflineProgress'?'#fafd16':'#ffffff'
          }"
          >
          营业厅业务
        </span> -->
      </template>
      <template #left>
        <span class="iconfont iconshang comm-rotate-270"></span>
        <span class="comm-return">返回</span>
      </template>
    </van-nav-bar>
    <div class="comm-topbar-height" v-show="$comm.titleShow()"></div>
    <component :is="currentTabComponent"></component>
    <div class="comm-homebar-height"></div>
    <home-bar></home-bar>
  </div>
</template>

<script>
import HomeBar from '@/components/HomeBar.vue'
import OnlineProgress from './BussOnline'
import OfflineProgress from './BussOffline'
export default {
  name: 'BusinessProgress',
  components: {
    HomeBar,
    OnlineProgress,
    OfflineProgress
  },
  data() {
    return {
      active: 0,
      typeList: [],
      typeCode: '',
      typeName: '',
      currentTabComponent: 'OnlineProgress',
      refreshFlag: null
    }
  },
  mounted() {
    // if (this.$route.query.active) {
    //   this.active = Number(this.$route.query.active)
    // }
  },
  activated() {
    // 前进刷新，后退缓存处理
    if (this.$route.meta.isUseCache) {
      this.$route.meta.isUseCache = false
    } else {
      if (this.$route.query.active) {
        this.active = Number(this.$route.query.active)
      }
      if(this.active===0){
        this.currentTabComponent = 'OnlineProgress'
      }
    }
  },
  methods: {
    topChange (currentTabComponent) {
      this.currentTabComponent = currentTabComponent
    },
  },
}
</script>

<style lang="less" scoped>
.business-progress{
  background:#f5f5f5;
}
</style>